
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-animated/-embroider-implicit-modules.js";
